import { render } from "./acledaPayment.vue?vue&type=template&id=2426774c&scoped=true"
import script from "./acledaPayment.vue?vue&type=script&lang=js"
export * from "./acledaPayment.vue?vue&type=script&lang=js"

import "./acledaPayment.vue?vue&type=style&index=0&id=2426774c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2426774c"

export default script